/**
 * @generated SignedSource<<7880b86b12c784170c3e9d5269ce159c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type WorkAvailability_userProfile$data = {
  readonly visitorCanEdit: boolean;
  readonly workPreferences: {
    readonly isCurrentlyAvailable: boolean;
  };
  readonly " $fragmentSpreads": FragmentRefs<"UpdateAvailabilityModal_userProfile" | "WorkAvailabilityTag_userProfile">;
  readonly " $fragmentType": "WorkAvailability_userProfile";
};
export type WorkAvailability_userProfile$key = {
  readonly " $data"?: WorkAvailability_userProfile$data;
  readonly " $fragmentSpreads": FragmentRefs<"WorkAvailability_userProfile">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "WorkAvailability_userProfile",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "visitorCanEdit",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "WorkPreferences",
      "kind": "LinkedField",
      "name": "workPreferences",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isCurrentlyAvailable",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "UpdateAvailabilityModal_userProfile"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "WorkAvailabilityTag_userProfile"
    }
  ],
  "type": "UserProfile",
  "abstractKey": null
};

(node as any).hash = "0fe4ad23112e240a3c248ad1ba97dc22";

export default node;
